"use client";
import Modal from "./Modal";
import Loader from "./Loader";
import SimpleLoader from "./ButtonLoader";
import ButtonLoader from "./ButtonLoader";
import Tabs from "./Tabs";
import ComingSoon from "./ComingSoon";
import RefreshButton from "./RefreshButton";
import NotFound from "./NotFound";
import Table from "./Table";
export {
  Table,
  NotFound,
  ButtonLoader,
  Loader,
  Tabs,
  Modal,
  SimpleLoader,
  ComingSoon,
  RefreshButton,
};
